import { FC, useEffect } from 'react';
import { cn, isTelegramWebApp } from '@/shared/lib';
import { useScreenWidth } from '@/shared/hooks';
import { useTranslation } from 'react-i18next';
import { Modal, Typography } from '@/shared/components';
import { DeliveryAddressContent } from './DeliveryAddressContent';
import { useAppDispatch, useAppSelector, closeDeliveryAddressModal } from '@/app/store';

export const DeliveryAddressModal: FC = () => {
  const dispatch = useAppDispatch();
  const isTgWebApp = isTelegramWebApp();
  const { isDesktop } = useScreenWidth();
  const { t: tAddress } = useTranslation('address');
  const { isOpen, isOrderAnotherPerson } = useAppSelector((state) => state.application.deliveryAddressModal);

  // Desktop web: a browser "back" while the modal is open should close it, not
  // navigate the page behind it. Telegram is handled in useTelegramBackButton.
  useEffect(() => {
    if (!isOpen || isTgWebApp) return;
    window.history.pushState({ deliveryAddressModal: true }, '');
    const onPopState = () => dispatch(closeDeliveryAddressModal());
    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, [isOpen, dispatch, isTgWebApp]);

  if (!isOpen) return null;

  const onClose = () => dispatch(closeDeliveryAddressModal());
  const content = (
    <DeliveryAddressContent isOrderAnotherPerson={isOrderAnotherPerson} onClose={onClose} isModal={isDesktop} />
  );

  if (isDesktop) {
    return (
      <Modal
        onClose={onClose}
        isDialog
        contentClassName='max-w-[868px] h-[708px] max-h-[90dvh] overflow-hidden flex flex-col px-0 pt-6 pb-0'
      >
        <Typography variant='h2' className='px-6 font-medium'>
          {tAddress('modal.title')}
        </Typography>
        <div className='flex-1 min-h-0'>{content}</div>
      </Modal>
    );
  }

  return (
    <div className={cn('fixed inset-0 z-[11] bg-background', isTgWebApp && 'mt-full-screen-header pb-2')}>
      {content}
    </div>
  );
};
